import axios from "axios";

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

// Não fixar X-CSRF-TOKEN a partir do <meta> do primeiro HTML.
// O login (e qualquer session()->regenerate()) troca o token e o
// cookie XSRF-TOKEN, mas o Inertia não reescreve o <head>. O Laravel
// usa o header X-CSRF-TOKEN se ele existir e ignora o cookie. O header
// velho faz o primeiro POST depois da navegação falhar até um reload.

// Interceptor para capturar erros 403 de 2FA
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        // Se for erro 403 com requires_2fa_confirmation, adicionar flag no erro.
        // ApiResponseService::error devolve a flag dentro de `errors`.
        const data = error.response?.data;
        if (
            error.response?.status === 403 &&
            (data?.requires_2fa_confirmation || data?.errors?.requires_2fa_confirmation)
        ) {
            error.requires_2fa_confirmation = true;
        }
        return Promise.reject(error);
    }
);

window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
